import { createFuncDef } from "./index.js";

export default callback => [createFuncDef(callback)];
